import { IHexSpaceData } from 'js/bubbleCore/types';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import { updatePositionInSpace } from 'js/bubbleCore/handlers/updatePositionInSpace';
import { IEvent } from 'js/bubbleCore/events';
import { loopSpace } from 'js/bubbleCore/utils/loopSpace';

export function updateBubblesInSpace(
  space: IHexSpaceData<Bubble>,
  events: IEvent[] = [],
): IEvent[] {
  loopSpace(space, (bubble) => {
    updatePositionInSpace(bubble, space, events);
  });
  return events;
}

